// extracted by mini-css-extract-plugin
module.exports = {"menu":"MoreActions_menu__24eue","menuItem__danger":"MoreActions_menuItem__danger__wr6M-"};